<script setup lang="ts" generic="T extends SelectInputType = string">
import type { SelectInputType } from '@modules/forms/types';
import VButton from '@components/buttons/VButton/VButton.vue';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { TRANSLATION_GROUP_MULTI_SELECT } from '@modules/forms/constants';

import type { IFormPlainDataListboxFooterEmits, IFormPlainDataListboxFooterProps } from './types';
import { ListboxSortType } from '../VFormPlainDataListbox/types';

withDefaults(defineProps<IFormPlainDataListboxFooterProps>(), {});
const emit = defineEmits<IFormPlainDataListboxFooterEmits>();
</script>

<template>
  <div v-data-qa-auto-id="'VFormPlainDataListboxFooter'"
    v-data-test="{ el: 'multiselect-footer' }"
    class="flex flex-col gap-4 px-4 py-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between"
  >
    <div class="flex items-center gap-1 text-sm sm:flex-none">
      <span class="word-break">
        {{ $getTranslation(TRANSLATION_GROUP_MULTI_SELECT, 'SELECTED') }}
      </span>
      <span class="font-medium">{{ checked }}</span>
      <span class="word-break">
        {{ $getTranslation(TRANSLATION_GROUP_MULTI_SELECT, 'FROM') }}
      </span>
      <span class="font-medium">{{ total }}</span>
    </div>
    <div class="flex flex-1 justify-end gap-2 text-right sm:flex-none">
      <VIconButton
        v-if="sortButton"
        :icon="sortType === ListboxSortType.DEFAULT ? 'pi-sort-alt-slash' : 'pi-sort-alt'"
        :class="sortType === ListboxSortType.DEFAULT ? 'text-muted-color' : ''"
        :disabled="sortButtonDisabled"
        @click="emit('sort')"
      />
      <VButton
        v-if="uploadFileBtn"
        v-data-test="{ el: 'multiselect-import-csv' }"
        :label="$getTranslation(TRANSLATION_GROUP_MULTI_SELECT, 'IMPORT_FROM_CSV')"
        :disabled="disabledButtons"
        text
        @click="emit('upload-file')"
      />
      <VButton
        v-data-test="{ el: 'multiselect-clear-all' }"
        :label="$getTranslation(TRANSLATION_GROUP_MULTI_SELECT, 'CLEAR_ALL')"
        :disabled="disabledButtons || checked === 0"
        text
        @click="emit('clear-all')"
      />
      <VButton
        v-data-test="{ el: 'multiselect-check-all' }"
        :label="$getTranslation(TRANSLATION_GROUP_MULTI_SELECT, 'CHECK_ALL')"
        :disabled="disabledButtons || total <= checked"
        text
        @click="emit('check-all')"
      />
    </div>
  </div>
</template>
